import React from 'react';
import { Link } from 'react-router-dom';
import { Navigation } from 'lucide-react';

// Geographic adjacency map — each city lists its nearest neighbors
const NEARBY = {
  "dallas":      ["richardson", "garland", "mesquite", "irving", "las-colinas", "plano"],
  "plano":       ["richardson", "frisco", "garland", "wylie", "sachse", "dallas"],
  "garland":     ["richardson", "dallas", "mesquite", "sachse", "wylie", "rockwall"],
  "mesquite":    ["dallas", "garland", "rockwall", "heath", "sachse"],
  "frisco":      ["plano", "richardson", "wylie", "sachse"],
  "rockwall":    ["heath", "garland", "mesquite", "wylie", "sachse"],
  "heath":       ["rockwall", "mesquite", "garland", "wylie"],
  "richardson":  ["dallas", "plano", "garland", "frisco", "las-colinas"],
  "wylie":       ["sachse", "plano", "garland", "rockwall", "frisco"],
  "sachse":      ["wylie", "garland", "plano", "richardson", "rockwall"],
  "las-colinas": ["irving", "dallas", "richardson", "grapevine"],
  "irving":      ["las-colinas", "dallas", "grapevine", "colleyville"],
  "southlake":   ["grapevine", "colleyville", "irving", "las-colinas"],
  "grapevine":   ["southlake", "colleyville", "irving", "las-colinas"],
  "colleyville": ["southlake", "grapevine", "irving", "las-colinas"]
};

const CITY_NAMES = {
  "dallas": "Dallas", "plano": "Plano", "garland": "Garland",
  "mesquite": "Mesquite", "frisco": "Frisco", "rockwall": "Rockwall",
  "heath": "Heath", "richardson": "Richardson", "wylie": "Wylie",
  "sachse": "Sachse", "las-colinas": "Las Colinas", "irving": "Irving",
  "southlake": "Southlake", "grapevine": "Grapevine", "colleyville": "Colleyville"
};

const NearbyCities = ({ citySlug, serviceId, serviceShort }) => {
  const neighbors = NEARBY[citySlug];
  if (!neighbors) return null;
  const cityName = CITY_NAMES[citySlug] || citySlug;

  return (
    <section className="bg-amber-50/50 border border-amber-200/60 rounded-2xl p-8 mt-4" data-testid="nearby-cities">
      <div className="flex items-center gap-2 mb-4">
        <Navigation className="w-5 h-5 text-amber-600" />
        <h2 className="text-xl font-bold text-neutral-900">
          {serviceShort} Services Near {cityName}
        </h2>
      </div>
      <p className="text-neutral-600 text-sm mb-5">
        Also serving these communities adjacent to {cityName} with professional {serviceShort.toLowerCase()} services:
      </p>
      <div className="flex flex-wrap gap-3">
        {neighbors.map(slug => (
          <Link
            key={slug}
            to={`/services/${serviceId}/${slug}`}
            className="inline-flex items-center gap-1.5 px-4 py-2 bg-white border border-amber-200 hover:border-amber-400 hover:bg-amber-50 rounded-lg transition-colors group"
          >
            <span className="w-1.5 h-1.5 bg-amber-400 rounded-full" />
            <span className="text-sm font-medium text-neutral-700 group-hover:text-amber-700">
              {serviceShort} in {CITY_NAMES[slug]}, TX
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
};

export default NearbyCities;
